<template>
  <VanPopup
    :show="show"
    class="md:max-w-md"
    closeable
    round
    @update:show="emit('update:show', $event)"
  >
    <div
      class="flex flex-col items-center justify-center p-8 text-center gap-3"
    >
      <div class="flex flex-col gap-2 items-center justify-center">
        <IShapeIcon class="w-8 h-8 text-warning" />
        <div class="text-2xl font-semibold text-warning">
          {{ t(`nsfw.sensitiveContent`) }}
        </div>
      </div>
      <p class="text-base font-normal">
        {{
          userStore.isLogin
            ? t(`nsfw.age.content`)
            : t(`nsfw.sensitiveContentDesc`)
        }}
      </p>

      <div class="flex flex-col gap-4">
        <template v-if="!userStore.isLogin">
          <button
            class="btn btn-primary"
            @click="userStore.loginModal.show = true"
          >
            {{ $t("User.login") }}
          </button>
        </template>
        <template v-else>
          <button class="btn btn-warning" @click="clickEnter">
            {{ t(`nsfw.age.enter`) }}
          </button>

          <button class="btn" @click="clickExit">
            {{ t(`nsfw.age.exit`) }}
          </button>
        </template>
      </div>
    </div>
  </VanPopup>
</template>
<script lang="ts" setup>
import { useGlobalUser } from "@/stores/globalUser";
import { showLoadingToast } from "vant";
import { onMounted, watch } from "vue";
import { useI18n } from "vue-i18n";

const userStore = useGlobalUser();

defineProps({
  show: {
    type: Boolean,
    required: true,
  },
});

const emit = defineEmits({
  "update:show": (val: boolean) => undefined,
  enter: () => undefined,
});
const { t } = useI18n();

watch(
  () => userStore.isLogin,
  (isLogin) => {
    if (
      isLogin &&
      userStore.user.isAdult &&
      userStore.user.isNsfwVisible === 1
    ) {
      emit("enter");
      emit("update:show", false);
    }
  }
);

const clickEnter = async () => {
  const loading = showLoadingToast({
    duration: 0,
    message: t("Message.updating"),
  });
  await userStore.updateUserApi({ isAdult: true, isNsfwVisible: 1 });
  loading.close();
  emit("update:show", false);
  emit("enter");
};

const clickExit = () => {
  emit("update:show", false);
};

onMounted(() => {});
</script>
